
import {Component, Prop, Vue} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';

@Component({
  name: 'store-search',
  components: ServiceContainer().getComponents(),
})
export default class extends Vue {
  @Prop() private query:string = '';

  private isLoading: boolean = false;
  private searchValue: String =  '';
  private error = null;

  private searchStore():void {
    if (this.searchValue) {
      this.error = null;
      this.$store.dispatch('StoreLocator/setSearchStore', this.searchValue);
    } else {
      this.error = 'Vul een geldige waarde in.';
    }
  }

  private mounted():void {
    this.$nextTick(() => {
      if ('' !== this.searchValue) {
        this.searchStore();
      }
    });
  }

}
